import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const navLinks = [
  { to: "/", label: "首页", end: true },
  { to: "/statements", label: "声明公告库" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-lg font-bold text-background-50 font-heading">
            黑
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold tracking-wide text-foreground-950">
              {siteInfo.name}
            </span>
            <span className="hidden text-[11px] text-foreground-500 sm:block">
              声明 · 辟谣 · 澄清
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
          {navLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-50 font-medium text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex cursor-pointer"
          >
            提交线索
          </Link>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="移动端导航"
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden"
        >
          <ul className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `block rounded-md px-3 py-2.5 text-sm cursor-pointer ${
                      isActive
                        ? "bg-primary-50 font-medium text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li>
              <Link
                to="/contact"
                className="mt-1 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 cursor-pointer"
              >
                提交线索
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}